/* KAMOK_ACCESSIBILITY_TOOLS_V2: all copies of controls stay in sync. */
(()=>{if(window.__kmAccessToolsV2Init)return;window.__kmAccessToolsV2Init=true;
  const roots=[...document.querySelectorAll('[data-km-access-tools]')];
  if(!roots.length)return;
  const key='km-access-tools-v1';
  const choices=['large','contrast','motion'];
  let settings={large:false,contrast:false,motion:false};
  try{const saved=JSON.parse(localStorage.getItem(key)||'{}');for(const k of choices)settings[k]=saved[k]===true;}catch(e){}
  function render(msg=''){
    for(const k of choices)document.documentElement.classList.toggle('km-access-'+k,settings[k]);
    for(const root of roots){
      root.querySelectorAll('[data-km-access-toggle]').forEach(button=>{
        const k=button.dataset.kmAccessToggle;
        if(!choices.includes(k))return;
        const active=!!settings[k];
        button.setAttribute('aria-pressed',String(active));
        button.dataset.active=active?'true':'false';
        const mark=button.querySelector('[data-km-access-mark]');
        if(mark)mark.textContent=active?'✓ Įjungta':'○ Išjungta';
      });
      const status=root.querySelector('[data-km-access-status]');
      if(status)status.textContent=msg;
    }
  }
  function save(){try{localStorage.setItem(key,JSON.stringify(settings))}catch(e){}}
  for(const root of roots){
    root.querySelectorAll('[data-km-access-toggle]').forEach(button=>button.addEventListener('click',()=>{
      const k=button.dataset.kmAccessToggle;
      if(!choices.includes(k))return;
      settings[k]=!settings[k];
      save();render(settings[k]?'Funkcija įjungta.':'Funkcija išjungta.');
    }));
    root.querySelector('[data-km-access-reset]')?.addEventListener('click',()=>{
      settings={large:false,contrast:false,motion:false};
      save();render('Nustatymai atstatyti.');
    });
  }
  document.addEventListener('keydown',e=>{
    if(e.key!=='Escape')return;
    for(const root of roots){if(root.open){root.open=false;root.querySelector('summary')?.focus()}}
  });
  document.addEventListener('pointerdown',e=>{
    for(const root of roots){if(root.open&&!root.contains(e.target))root.open=false}
  });
  render();
})();